
const noop = () => {};
const tag_prefix = `---------------------------------------------------------------- `;
const format_event_log = (name, source, value) => {
  return `~~>>>>$$$$$$$%%%%%%%%%%%%%%%% ${name} [${source}] > ${value || ''} ********************************`;
};

export default (active, tag) => {
  return {
    enter: active ? (method) => console.log(tag_prefix + tag + `\n> ` + method) : noop,
    log: active ? function() {[...arguments].forEach((arg) => console.log(arg))} : noop,
    event: active ? (handler, info) => {
      if (typeof info === `object`) {
        console.log(format_event_log(handler, tag));
        console.log(info);
      } else {
        console.log(format_event_log(handler, tag, info));
      }
    } : noop,
  }
};

const createUtilDebugLogger = (active) => {
  return {
    enter: active ? (name) => console.group(name) : noop,
    log: active ? function() {[...arguments].forEach((arg) => console.log(arg))} : noop,
    exit: active ? () => console.groupEnd() : noop,
  }
};

export {
  createUtilDebugLogger,
}


// WEBPACK FOOTER //
// ./src/utils/createLogger.js